/**
 * This is a temporary solution of moving dynamic import out of
 * CoffeeScript code. It unblocks the possibility of using
 * bulk decaffeination tool.
 * After decaf process will be completed, imports should go back inline.
 */
import { importWithRetry } from '@trello/use-lazy-component';

export const markerClustererLoader = () =>
  importWithRetry(() =>
    import(
      /* webpackChunkName: "google-marker-cluster-plus" */ '@google/markerclustererplus'
    ),
  ).then((m) => m.default);
